import React, { useState, useEffect, useRef } from 'react'
import Navbar from "../../component/HeaderData";
import Footer from "../../component/FooterData";
import BackButton from '../../component/Common/BackBtn'
import { useMsal } from '@azure/msal-react'
import { useHistory, useLocation } from 'react-router-dom'
import ReactDataGrid from '@inovua/reactdatagrid-enterprise'
import Button from '../../component/Common/Button'
import Dropdown from "../../component/Common/Dropdown";
import InputText from '../../component/Common/InputText'
import FormInput from '../../component/Common/FormInput'
import _, { set } from 'lodash'
import './sftp-report-home.css'
import PageSubTitle from '../../component/Common/PageSubTitle'
import ReactQuill from 'react-quill'
import 'react-quill/dist/quill.snow.css';
import moment from 'moment'
import Modal from 'react-modal';
import { FaExternalLinkAlt, FaDownload } from 'react-icons/fa';
import Cookies from 'js-cookie';
import { toast } from 'react-toastify';
import { BlobServiceClient, ContainerClient } from '@azure/storage-blob';
import axios from '../../utils/axiosConfig';

// Azure Blob Upload Service - Added directly in the component
class AzureBlobUploadService {
    private static containerClient: ContainerClient | null = null;

    private static initialize() {
        if (!this.containerClient) {
            const accountName = 'sadhhsmcosys001';
            const sasToken = 'sv=2022-11-02&ss=bfqt&srt=sco&sp=rwdlacupiytfx&se=2027-06-11T02:29:20Z&st=2024-12-11T19:29:20Z&spr=https&sig=EljbGDvbX%2BHHD9YGnMoJ0nkZxRghYV5ka6Dj2q%2BbEoM%3D';
            const containerName = 'mcofiles';

            // FIX: Create ContainerClient directly with the full container URL + SAS
            const containerUrl = `https://${accountName}.blob.core.windows.net/${containerName}?${sasToken}`;
            this.containerClient = new ContainerClient(containerUrl);
        }
    }

    static async uploadFiles(files: File[]): Promise<{ success: boolean; fileNames: string[]; urls: string[]; blobNames: string[] }> {
        try {
            this.initialize();

            if (!this.containerClient) {
                throw new Error('Azure Blob Storage not properly configured');
            }

            const uploadPromises = files.map(async (file) => {
                const timestamp = new Date().getTime();
                const blobName = `POCFOLDER/${timestamp}-${file.name}`;
                const blockBlobClient = this.containerClient!.getBlockBlobClient(blobName);

                console.log(`Uploading ${file.name} to Azure Blob Storage...`);

                // ACTUAL upload to Azure Blob Storage
                const uploadResponse = await blockBlobClient.uploadData(file, {
                    blobHTTPHeaders: {
                        blobContentType: file.type
                    },
                    metadata: {
                        reportId: '2494',
                        originalFileName: file.name
                    }
                });

                console.log(`Successfully uploaded ${file.name}:`, uploadResponse);

                return {
                    fileName: file.name,
                    blobName: blobName,
                    url: blockBlobClient.url
                };
            });

            const results = await Promise.all(uploadPromises);
            const fileNames = results.map(r => r.fileName);
            const urls = results.map(r => r.url);
            const blobNames = results.map(r => r.blobName);

            return { success: true, fileNames, urls, blobNames };
        } catch (error) {
            console.error('Azure Blob upload error:', error);
            throw error;
        }
    }

    static async deleteFile(blobName: string): Promise<void> {
        try {
            this.initialize();
            if (this.containerClient) {
                await this.containerClient.deleteBlob(blobName);
                console.log(`File ${blobName} deleted successfully`);
            }
        } catch (error) {
            console.error('Error deleting file:', error);
            throw error;
        }
    }
}

// Keep the local service as fallback
class FileUploadServiceLocal {
    static async uploadFiles(files: File[]): Promise<{ success: boolean; fileNames: string[]; urls?: string[] }> {
        return new Promise((resolve, reject) => {
            setTimeout(() => {
                try {
                    const fileNames = files.map(file => file.name);
                    console.log('Files uploaded (simulation):', fileNames);
                    resolve({ success: true, fileNames });
                } catch (error) {
                    console.error('Upload error:', error);
                    reject({ success: false, fileNames: [], error });
                }
            }, 1500);
        });
    }
}
export default function SftpReportDetails() {
    const { instance, accounts } = useMsal()
    const history = useHistory()
    const [isLoading, setIsLoading] = useState(false)
    const location = useLocation();
    const loggedInUserDetails = JSON.parse(sessionStorage.getItem('loginUserDetails') || '{}');
    const isNonStateUser = loggedInUserDetails.organizationUnitCode !== "NEDHHS";
    const userType = sessionStorage.getItem('signedInUserType');

    useEffect(() => {
        setIsLoading(true);
        const timeoutId = setTimeout(() => {
            if (userType === null && (!accounts?.[0]?.localAccountId)) {
                history.push('/sign-in');
            }
            setIsLoading(false);
        }, 1000);

        return () => clearTimeout(timeoutId);
    }, [accounts, history, userType]);

    interface SFTPReport {
        sftpUploadDatetime: string;
        fileName: string;
        mcoName: string;
        associatedReportName: string;
        frequency: string;
        period: string;
        dueDate: string;
        currentSubmission: string;
        submissinStatus: string;
        lastUpdatedDate: string;
        lastUpdatedBy: string;
        fileType: string;
        uploadFiles?: string;
    };

    interface LocationState {
        recordData?: SFTPReport;
    }

    const recordData = (location?.state as LocationState)?.recordData || null;

    function handleCancel() {
        history.goBack()
    }

    function handleSaveButton() {
    }



    const fileTypeDropdown = [
        { label: 'Main Report', value: 'Main Report' },
        { label: 'Associated File', value: 'Associated File' },
        { label: 'Additional Info', value: 'Additional Info' },
        { label: 'Certification Statement', value: 'Certification Statement' },
    ];

    const mcoNameDropdown = [
        { label: 'United Health Care', value: 'United Health Care' },
        { label: 'Nebraska Total Care', value: 'Nebraska Total Care' },
        { label: 'Molina', value: 'Molina' },
    ];

    const associationReportDropdown = [
        { label: 'EVV KPI-Home Health', value: 'EVV KPI-Home Health' },
        { label: 'Care Management Report', value: 'Care Management Report' },
        { label: 'Appeals Log', value: 'Appeals Log' },
        { label: 'Bi-Weekly Tips Report', value: 'Bi-Weekly Tips Report' },
    ];

    const reportPeriodDropdown = [
        { label: '06/01/24-06/30/24', value: '06/01/24-06/30/24' },
        { label: '07/01/24-07/31/24', value: '07/01/24-07/31/24' },
        { label: '07/16/24-07/31/24', value: '07/16/24-07/31/24' },
    ];

    const actionDropdown = [
        { label: 'Link to Report', value: 'Link to Report' },
        { label: 'Unlink from Report', value: 'Unlink from Report' },
        { label: 'Submit for next process', value: 'Submit for next process' },
        { label: 'Link to report and submit for next process', value: 'Link to report and submit for next process' },
    ];
    const handleRichTextChangeNotes = (event: any, name: any) => {
        // setBusinessOutcome((prevState: any) => ({ ...prevState, [name]: event }))
    }
    function joinClasses(...classes: (string | undefined)[]): string {
        return classes.filter(Boolean).join(' ')
    }
    const wrapperClasses = joinClasses('usa-fieldset usa-form-group')
    const [mcoName, setMcoName] = useState('');
    const [actionValue, setActionValue] = useState('');
    const [associatedReportName, setAssociatedReportName] = useState('');
    const [reportPeriod, setReportPerios] = useState('');
    function handleGeneralInputData(event: any) {
        const { name, value } = event.target
        setMcoName(value)
        // setUploadNewReport((prevState: any) => ({ ...prevState, [name]: value }))
    }
    function handleAssociatedData(event: any) {
        const { name, value } = event.target
        setAssociatedReportName(value)
        // setUploadNewReport((prevState: any) => ({ ...prevState, [name]: value }))
    }
    function handleReportPeriodData(event: any) {
        const { name, value } = event.target
        setReportPerios(value)
        // setUploadNewReport((prevState: any) => ({ ...prevState, [name]: value }))
    }

    function handleActionDropdowm(event: any) {
        const { name, value } = event.target
        setActionValue(value)
        // setUploadNewReport((prevState: any) => ({ ...prevState, [name]: value }))
    }
    useEffect(() => {
        if (recordData) {
            setMcoName(recordData.mcoName);
            setAssociatedReportName(recordData.associatedReportName);
            setReportPerios(recordData.period);
        }
    }
        , [recordData]);

    const formatDateForInput = (dateString: string) => {
        let parts;
        if (dateString.includes('/')) {
            parts = dateString.split('/');
            return `${parts[2]}-${parts[0]}-${parts[1]}`;
        } else if (dateString.includes('-')) {
            parts = dateString.split('-');
            return `${parts[0]}-${parts[1]}-${parts[2]}`;
        }
        return '';
    }

    type UploadFile = {
        id: string;
        name: string;
        type: string;
    };

    const formattedDueDate = recordData?.dueDate ? formatDateForInput(recordData.dueDate) : '';
    const [fileValue, setFileValue] = useState<UploadFile>({ id: '', name: '', type: '' });

    useEffect(() => {
        if (recordData && typeof recordData.uploadFiles === 'object') {
            const uploadedFiles: UploadFile = recordData.uploadFiles ? recordData.uploadFiles : { id: '', name: '', type: '' };
            setFileValue(uploadedFiles);
        }
    }, [recordData]);


    const handleRichTextChangeAppDetails = (event: any) => {
        const appDetails = event
    }

    const initialCheckboxState = true;

    const [isChecked, setIsChecked] = useState(initialCheckboxState);

    useEffect(() => {
        setIsChecked(initialCheckboxState);
    }, [initialCheckboxState]);

    useEffect(() => {
        if (recordData?.period && recordData?.frequency && recordData?.associatedReportName && recordData?.mcoName && recordData?.fileName &&
            recordData?.currentSubmission && recordData?.submissinStatus && recordData?.dueDate && recordData?.sftpUploadDatetime
        ) {
            setIsChecked(true);
        } else {
            setIsChecked(false);
        }
    }, [recordData]);

    const handleCheckboxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const checked = e.target.checked;
        setIsChecked(checked);

        if (!checked) {
            if (isNonStateUser) {
                setMcoName('Molina');
                setAssociatedReportName('');
                setReportPerios('');
            }
            else {
                setMcoName('');
                setAssociatedReportName('');
                setReportPerios('');
            }
        }
    };

    // File upload states
    const [uploadedFileNames, setUploadedFileNames] = useState<string[]>([]);
    const [uploadedFileUrls, setUploadedFileUrls] = useState<string[]>([]);
    const [isUploading, setIsUploading] = useState(false);
    const [useAzureBlob, setUseAzureBlob] = useState(true);
    // Simple file upload handler
    // Update your handleFileSelect function to fallback to local service on CORS error
    const handleFileSelect = async (event: React.ChangeEvent<HTMLInputElement>) => {
        const files = event.target.files;
        if (files && files.length > 0) {
            setIsUploading(true);

            try {
                const fileArray = Array.from(files);
                let result: any;

                if (useAzureBlob) {
                    try {
                        // Try Azure Blob Storage first
                        result = await AzureBlobUploadService.uploadFiles(fileArray);
                        if (result.success && result.urls) {
                            setUploadedFileUrls(prev => [...prev, ...result.urls!]);
                        }
                    } catch (azureError: any) {
                        // If CORS error, fallback to local service
                        if (azureError.message && azureError.message.includes('CORS')) {
                            console.warn('CORS error detected, falling back to local upload');
                            toast.warning('Azure upload failed due to CORS, using local fallback');
                            result = await FileUploadServiceLocal.uploadFiles(fileArray);
                        } else {
                            throw azureError;
                        }
                    }
                } else {
                    // Use local simulation
                    result = await FileUploadServiceLocal.uploadFiles(fileArray);
                }

                if (result.success) {
                    setUploadedFileNames(prev => [...prev, ...result.fileNames]);
                    toast.success(
                        `${files.length} file(s) uploaded successfully!`
                    );

                    // Debug: Log the result object to see what's returned
                    console.log('Upload result:', result);
                    console.log('Blob names:', result.blobNames);

                    // Call validation API for each uploaded file
                    if (result.blobNames && result.blobNames.length > 0) {
                        console.log('Starting file validation for', result.blobNames.length, 'files...');

                        for (const blobName of result.blobNames) {
                            try {
                                const containerName = 'mcofiles';
                                // Base64 encode the filename to handle special characters and slashes
                                const encodedFileName = btoa(blobName);
                                const apiUrl = `/api/mcfile/downloadAndValidateFileByFileName/${containerName}/${encodedFileName}`;

                                console.log(`Calling validation API: ${apiUrl}`);
                                console.log(`Original filename: ${blobName}, Base64 encoded: ${encodedFileName}`);

                                const validationResponse = await axios.get(apiUrl);

                                console.log(`Validation response for ${blobName}:`, validationResponse.data);

                                if (validationResponse.data.success) {
                                    console.log(`Validation successful for ${blobName}:`, validationResponse.data);
                                    toast.success(`Validation completed for ${validationResponse.data.fileName}`);
                                } else {
                                    console.warn(`Validation failed for ${blobName}:`, validationResponse.data);
                                    toast.warning(`Validation failed for ${blobName}: ${validationResponse.data.errorMessage}`);
                                }
                            } catch (validationError: any) {
                                console.error(`Validation API error for ${blobName}:`, validationError);
                                toast.error(`Validation error for ${blobName}: ${validationError.response?.data || validationError.message}`);
                            }
                        }
                    } else {
                        console.warn('No blob names returned from upload. Validation skipped.');
                        console.log('Result object keys:', Object.keys(result));
                    }
                }
            } catch (error) {
                console.error('Error uploading files:', error);
                toast.error('Error uploading files');
            } finally {
                setIsUploading(false);
                if (fileInputRef.current) {
                    fileInputRef.current.value = '';
                }
            }
        }
    };

    const handleUploadClick = () => {
        fileInputRef.current?.click();
    };

    const removeUploadedFile = (index: number) => {
        setUploadedFileNames(prev => prev.filter((_, i) => i !== index));
        // setUploadedFileUrls(prev => prev.filter((_, i) => i !== index));
    };
    const fileInputRef = useRef<HTMLInputElement>(null);

    return (
        <>
            <Navbar />
            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center' }}>
                <div style={{ alignSelf: 'flex-start' }}>
                    <BackButton />
                </div>
                <div style={{ width: '100%', display: 'flex', justifyContent: 'center', marginTop: '20px' }}>
                    <PageSubTitle text="SFTP Files" />
                </div>
            </div>

            <div className="form-layout">
                <div className="external-filters-action flex flex-row justify-end w-full md:w-auto" style={{ marginBottom: '-30px' }}>
                    <Button
                        className="OkButton"
                        onClick={() => handleCancel()}
                    >
                        Cancel
                    </Button>
                    <Button
                        className="OkButton"
                        onClick={() => handleSaveButton()}
                    >
                        Save
                    </Button>
                </div>

                <div className="row1" style={{ marginBottom: '20px', padding: '15px', backgroundColor: '#f8f9fa', borderRadius: '5px' }}>
                    <h4><b>File Upload:</b></h4>
                    <div style={{ display: 'flex', flexDirection: 'column', gap: '15px' }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                            <input
                                type="file"
                                ref={fileInputRef}
                                onChange={handleFileSelect}
                                multiple
                                style={{ display: 'none' }}
                                accept=".pdf,.doc,.docx,.xls,.xlsx,.txt,.csv,.zip"
                            />
                            <div style={{ display: 'inline-block', borderRadius: 4, backgroundColor: isUploading ? '#6c757d' : '#0066cc' }}>
                                <Button
                                    className="OkButton"
                                    onClick={handleUploadClick}
                                    disabled={isUploading}
                                >
                                    {isUploading ? 'Uploading...' : 'Upload Files'}
                                </Button>
                            </div>
                            {isUploading && (
                                <div style={{ fontSize: '14px', color: '#666' }}>
                                    Please wait while files are being uploaded...
                                </div>
                            )}
                        </div>
                        {/* Uploaded Files Display */}
                        {uploadedFileNames.length > 0 && (
                            <div>
                                <h5 style={{ color: '#28a745', marginBottom: '10px' }}>
                                    ✓ Uploaded Files ({uploadedFileNames.length}):
                                </h5>
                                <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                                    {uploadedFileNames.map((fileName, index) => (
                                        <li
                                            key={index}
                                            style={{
                                                display: 'flex',
                                                justifyContent: 'space-between',
                                                alignItems: 'center',
                                                padding: '8px 12px',
                                                backgroundColor: '#d4edda',
                                                margin: '4px 0',
                                                borderRadius: '4px',
                                                border: '1px solid #c3e6cb'
                                            }}
                                        >
                                            <span style={{ color: '#155724', fontWeight: '500' }}>
                                                📎 {fileName}
                                            </span>
                                            <button
                                                type="button"
                                                onClick={() => removeUploadedFile(index)}
                                                style={{
                                                    backgroundColor: '#dc3545',
                                                    color: 'white',
                                                    padding: '4px 8px',
                                                    fontSize: '12px',
                                                    border: 'none',
                                                    borderRadius: '3px',
                                                    cursor: 'pointer'
                                                }}
                                            >
                                                Remove
                                            </button>
                                        </li>
                                    ))}
                                </ul>
                            </div>
                        )}
                    </div>
                </div>


                <div className="details-block">
                    <h3><b>Filter Criteria:</b></h3>
                    <div className="row1">
                        <div className="element" >
                            <InputText
                                context="registration"
                                label="SFTP File Name"
                                name="fileName"
                                placeholder="File Name"
                                value={recordData?.fileName}
                                onChange={handleGeneralInputData}
                                disabled={true}
                            />
                        </div>
                        <div className="element" >
                            <InputText
                                context="registration"
                                label="SFTP Upload Datetime"
                                name="sftpUploadDatetime"
                                placeholder="SFTP Upload Datetime"
                                value={recordData?.sftpUploadDatetime}
                                onChange={handleGeneralInputData}
                                disabled={true}
                            />
                        </div>
                    </div>
                    <div className="row1">
                        <div className="element" >
                            <Dropdown
                                choices={mcoNameDropdown}
                                emptyChoiceLabel="Select MCO Name"
                                name="mcoName"
                                label="MCO Name "
                                data-testid="payment_type_testid"
                                value={mcoName}
                                onChange={handleGeneralInputData}
                                disabled={!isChecked && isNonStateUser}
                            />
                        </div>
                        <div className="element" >
                            <Dropdown
                                choices={associationReportDropdown}
                                emptyChoiceLabel="Select Associated Report Name"
                                name="associatedReportName"
                                label="Associated Report Name"
                                data-testid="payment_type_testid"
                                value={associatedReportName}
                                onChange={handleAssociatedData}
                            />

                        </div>
                    </div>
                    <div className="row1">
                        <div className="element" >
                            <Dropdown
                                choices={reportPeriodDropdown}
                                emptyChoiceLabel="Select Report Period"
                                name="period"
                                label="Report Period"
                                data-testid="payment_type_testid"
                                value={reportPeriod}
                                onChange={handleReportPeriodData}
                            />
                        </div>
                        <div className="element" >
                            <div className="usa-form-group ">
                                <input
                                    type="checkbox"
                                    id="isSelectedSftpCheckbox"
                                    style={{ margin: '30px', transform: 'scale(1.5)' }}
                                    checked={isChecked}
                                    onChange={handleCheckboxChange}

                                // onChange={(e) => setIsChecked(e.target.checked)}

                                />
                                <label htmlFor="isSelectedSftpCheckbox">
                                    Link SFTP File
                                </label>
                            </div>
                        </div>
                    </div>
                    <div className="row1">
                        <div className="element" >
                            <div className="usa-form-group">
                                <InputText
                                    context="registration"
                                    label="Report Frequency"
                                    name="frequency"
                                    placeholder="Frequency"
                                    value={recordData?.frequency}
                                    onChange={handleGeneralInputData}
                                    disabled={true}
                                />

                            </div>
                        </div>
                        <div className="element" >
                            <div className="usa-form-group">
                                <FormInput
                                    label="Report Due Date"
                                    type="date"
                                    name="dueDate"
                                    value={formattedDueDate}
                                    onChange={handleGeneralInputData}
                                    placeholder={'MM-DD-YYYY'}
                                    id={''}
                                    disabled={true}
                                />
                            </div>
                        </div>
                    </div>

                    <div className="row1" style={{ display: 'flex', justifyContent: 'space-between', marginTop: '20px' }}>
                        <div className="element" style={{ flex: 1, marginRight: '10px' }}>
                            <div style={{ display: 'flex', flexDirection: 'column', marginBottom: '1rem' }}>
                                <label >
                                    <b>Notes:</b>
                                </label>
                                <ReactQuill
                                    style={{ maxHeight: '150px', overflowY: 'auto', width: '100%', borderColor: '#3e3e3f', borderWidth: '1px' }}
                                    value={''}
                                    onChange={handleRichTextChangeAppDetails}
                                    modules={{
                                        toolbar: [
                                            ['bold', 'italic', 'underline', 'strike'], // formatting options
                                            [{ list: 'ordered' }, { list: 'bullet' }], // list options
                                            [{ align: [] }], // alignment options
                                            ['clean'], // remove formatting option
                                        ],
                                    }}
                                />
                            </div>
                        </div>
                    </div>
                    <div className='row1'>
                        <div className="element" >
                            <Dropdown
                                choices={fileTypeDropdown}
                                emptyChoiceLabel="Select File Type"
                                name="fileType"
                                label="File Type"
                                data-testid="payment_type_testid"
                                value={fileValue.type}
                                onChange={handleGeneralInputData}
                            />
                        </div>
                        <div className="element" >
                            <InputText
                                context="registration"
                                label="SFTP File Status"
                                name="submissinStatus"
                                placeholder="Submissin Status"
                                value={recordData?.submissinStatus}
                                onChange={handleGeneralInputData}
                                disabled={true}
                            />
                        </div>
                    </div>
                    <div className='row1'>
                        <div className="element" >
                            <Dropdown
                                choices={actionDropdown}
                                emptyChoiceLabel="Select Action"
                                name="action"
                                label="Select Action"
                                data-testid="payment_type_testid"
                                value={actionValue}
                                onChange={handleActionDropdowm}
                            />
                        </div>
                        <div className="element" >

                        </div>
                    </div>
                </div>

                <div className="row1">
                    <div className="element" >
                        <p><b>Last Updated By : </b>{recordData?.lastUpdatedBy}</p>
                    </div>
                    <div className="element" >
                        <p><b>Last Updated Date : </b>{recordData?.lastUpdatedDate}</p>
                    </div>
                </div>
            </div >
            <Footer />
        </>
    );
}